import type { EditorView } from '@codemirror/view'

const removeHeading = (line: string) => {
  let i = 0
  while (i < line.length && line[i] === '#') i++
  if (i > 0 && line[i] === ' ') {
    return line.slice(i + 1)
  }
  return line
}

export const insertHeading1 = (editorView: EditorView | null) => {
  if (!editorView) return
  const { from, to } = editorView.state.selection.main
  const doc = editorView.state.sliceDoc(0)

  let start = from
  let end = to

  if (start === end) {
    while (start > 0 && doc[start - 1] !== '\n') start--
    while (end < doc.length && doc[end] !== '\n') end++
  }

  const lines = doc.slice(start, end).split('\n')
  const newText = lines.map(line => `# ${removeHeading(line)}`).join('\n')

  editorView.dispatch({
    changes: { from: start, to: end, insert: newText },
    selection: { anchor: start + 2, head: start + 2 }
  })
  editorView.focus()
}

export const insertHeading2 = (editorView: EditorView | null) => {
  if (!editorView) return
  const { from, to } = editorView.state.selection.main
  const doc = editorView.state.sliceDoc(0)

  let start = from
  let end = to

  if (start === end) {
    while (start > 0 && doc[start - 1] !== '\n') start--
    while (end < doc.length && doc[end] !== '\n') end++
  }

  const lines = doc.slice(start, end).split('\n')
  const newText = lines.map(line => `## ${removeHeading(line)}`).join('\n')

  editorView.dispatch({
    changes: { from: start, to: end, insert: newText },
    selection: { anchor: start + 3, head: start + 3 }
  })
  editorView.focus()
}

export const insertHeading3 = (editorView: EditorView | null) => {
  if (!editorView) return
  const { from, to } = editorView.state.selection.main
  const doc = editorView.state.sliceDoc(0)

  let start = from
  let end = to

  if (start === end) {
    while (start > 0 && doc[start - 1] !== '\n') start--
    while (end < doc.length && doc[end] !== '\n') end++
  }

  const lines = doc.slice(start, end).split('\n')
  const newText = lines.map(line => `### ${removeHeading(line)}`).join('\n')

  editorView.dispatch({
    changes: { from: start, to: end, insert: newText },
    selection: { anchor: start + 4, head: start + 4 }
  })
  editorView.focus()
}

export const insertNormalText = (editorView: EditorView | null) => {
  if (!editorView) return
  const { from, to } = editorView.state.selection.main
  const doc = editorView.state.sliceDoc(0)

  let start = from
  let end = to

  if (start === end) {
    while (start > 0 && doc[start - 1] !== '\n') start--
    while (end < doc.length && doc[end] !== '\n') end++
  }

  const lines = doc.slice(start, end).split('\n')
  const newText = lines.map(line => removeHeading(line)).join('\n')

  editorView.dispatch({
    changes: { from: start, to: end, insert: newText },
    selection: { anchor: start, head: start }
  })
  editorView.focus()
}
